__turbopack_context__.v({
  "boostedTag": "DwMxCG_boostedTag",
  "brandName": "DwMxCG_brandName",
  "heartbeat": "DwMxCG_heartbeat",
  "likeButton": "DwMxCG_likeButton",
  "likeButtonUnfilled": "DwMxCG_likeButtonUnfilled",
  "likedButtonFilled": "DwMxCG_likedButtonFilled",
  "productAttributes": "DwMxCG_productAttributes",
  "productAttributesContainer": "DwMxCG_productAttributesContainer",
  "sizeAttributeText": "DwMxCG_sizeAttributeText",
  "translucentHoverOverlay": "DwMxCG_translucentHoverOverlay",
});
